<script>
import axios from 'axios';
import $ from 'jquery';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'IncurredExpenseModal',
  inject: ['eventHub'],
  components: {
    DatePicker,
  },
  created() {
    this.eventHub.$on('incurred-expense-modal', (customerService) => {
      this.init();
      this.loadExpenses();
      this.customerService = customerService;
      this.loadListIncurredExpense();
      $('#incurred-expense').modal('show');
    })
  },
  data () {
    return {
      customerService: false,
      date: new Date (),
      ticket: null,
      amount: 0,
      expenseId: null,
      note: '',
      customerServiceId: false,
      userId: false,
      incurredExpenses: false,
      incurredExpenseId: false,
      expenses: [],
      errors: {},
    }
  },
  methods: {
    init () {
      this.incurredExpenseId = false;
      this.date = new Date ();
      this.ticket = null;
      this.amount = 0;
      this.expenseId = null;
      this.note = '';
    },
    storeOrUpdate () {
      if (this.incurredExpenseId) {
        this.update();
      } else {
        this.store();
      }
    },
    store () {
      axios
        .post('/api/incurred-expense', {
          date: this.formatDate(this.date),
          ticket: this.ticket,
          amount: this.amount,
          expense_id: this.expenseId,
          note: this.note,
          customer_service_id: this.customerService.id
        })
        .then(() => {
          this.init();
          this.$toast.success("Despesa cadastrada com sucesso!")
          this.loadListIncurredExpense();
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.fail();
        })
    },
    update () {
      axios
        .put(`/api/incurred-expense/${this.incurredExpenseId}`, {
          date: this.formatDate(this.date),
          ticket: this.ticket,
          amount: this.amount,
          expense_id: this.expenseId,
          note: this.note,
          customer_service_id: this.customerService.id
        })
        .then(() => {
          this.init();
          this.$toast.success("Despesa atualizada com sucesso!")
          this.loadListIncurredExpense();
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.fail();
        })
    },
    destroy (incurredExpenseId) {
      axios
        .delete(`/api/incurred-expense/${incurredExpenseId}`)
        .then(() => {
          this.$toast.success("Despesa excluida com sucesso!")
          this.loadListIncurredExpense();
        })
        .catch(() => this.$toast.error("Falha ao excluir, tente novamente mais tarde!"))
    },
    loadExpenses () {
      axios
        .get('/api/expenses')
        .then(({ data }) => this.expenses = data)
    },
    loadListIncurredExpense () {
      axios
        .get(`/api/incurred-expense/ticket/${this.customerService.id}`)
        .then(({ data }) => this.incurredExpenses = data.data)
    },
    formatDateBrToView (originalDate) {
      const data = new Date(originalDate);
      let timezoneOffset = -180;
      data.setMinutes(data.getMinutes() - timezoneOffset);
      return data.toLocaleDateString("pt-BR");
    },
    formatDate (date) {
      return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
    },
    loadFormEdit (incurredExpense) {
      const date = new Date(incurredExpense.date);
      let timezoneOffset = -180;
      date.setMinutes(date.getMinutes() - timezoneOffset);

      this.date = date;
      this.expenseId = incurredExpense.expense_id;
      this.ticket = incurredExpense.ticket;
      this.amount = incurredExpense.amount;
      this.incurredExpenseId = incurredExpense.id;
      this.note = incurredExpense.note;
    },
    resetForm () {
      this.init();
    },
    fail() {
      let message = ''
      for (let i in this.errors) {
        message = this.errors[i] + '<br />' + message
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message
      });
    },
  }
}
</script>

<template>
  <div
    class="modal fade"
    id="incurred-expense"
    tabindex="-1"
    aria-labelledby="incurred-expense"
    aria-hidden="true"
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">Lançamento de despesas - Ticket Cliente {{ customerService.customer_name }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form v-on:submit.prevent="storeOrUpdate" class="task-made-form m-2">
            <div class="row">
              <div class="col-auto">
                <date-picker
                  v-model="date"
                  format="DD/MM/YY"
                  v-mask="'##/##/##'"
                />
              </div>
              <div class="form-group col-4 input-form">
                <v-select
                  :reduce="expenses => expenses.id"
                  placeholder="Tipo de despesa"
                  label="name"
                  v-model="expenseId"
                  :options="expenses"
                  v-show="expenses"
                />
              </div>
              <div class="form-group col-2 input-form">
                <input
                  class="form-control"
                  type="text"
                  v-model="ticket"
                  placeholder="NF/cupom"
                  name="ticket"
                  id="ticket"
                >
              </div>
              <div class="form-group col-3 input-form">
                <money class="form-control" v-model="amount" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="form-group col-8 input-form">
                <input
                  class="form-control"
                  type="text"
                  v-model="note"
                  placeholder="Observação"
                  name="note"
                  id="note"
                >
              </div>
              <div class="d-flex flex-row col-md-3 gap-2">
                <button type="submit" class="btn btn-success">Salvar</button>
                <button type="button" class="btn btn-secondary" @click="resetForm">Cancelar</button>
              </div>
            </div>
          </form>

          <section class="d-flex flex-column mt-4">
            <table class="table table-striped sm">
              <thead>
              <tr>
                <th>Data</th>
                <th>Despesa</th>
                <th>N° Ticket</th>
                <th>Valor</th>
                <th>Observação</th>
                <th>Ações</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="incurredExpense in incurredExpenses" :key="incurredExpense.id">
                <td>
                  {{formatDateBrToView(incurredExpense.date)}}
                </td>
                <td>{{incurredExpense.expense_name}}</td>
                <td>{{incurredExpense.ticket}}</td>
                <td><money class="hide-input" v-model="incurredExpense.amount" disabled/></td>
                <td>{{incurredExpense.note}}</td>
                <td>
                  <div class="d-flex flex-row gap-1">
                    <button
                      title="Editar"
                      type="button"
                      class="btn btn-outline-primary btn-sm mb-1"
                      v-on:click="loadFormEdit(incurredExpense)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      title="Excluir"
                      type="button"
                      class="btn btn-outline-danger btn-sm mb-1"
                      v-on:click="destroy(incurredExpense.id)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
